import { useEffect, useState } from 'react'
import { convertToLuxonWithTimeZone, nxConfig } from '@nv/utils'
import { DateTime } from 'luxon'

export const useCountdown = (countdownToDate) => {
  const countdownDate = convertToLuxonWithTimeZone(countdownToDate)

  const getCountdown = () => {
    let now = DateTime.now()
    const timeZone = nxConfig.timeZone
    if (timeZone) now = now.setZone(timeZone)
    const result = countdownDate.diff(now, ['days', 'hours', 'minutes', 'seconds']).toObject()

    return {
      days: Math.floor(result.days),
      hours: Math.floor(result.hours),
      minutes: Math.floor(result.minutes),
      seconds: Math.floor(result.seconds),
    }
  }

  const [countdown, setCountdown] = useState(getCountdown)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getCountdown())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return countdown
}
